import EE from "@antv/event-emitter"
import { getNativeInfo } from "../jsbridge"

export const eventEmitter = new EE()

export enum EventEmitterType {
  toggleTheme = "toggleTheme",
}
